<template>
    <div id="combineModuleNumbersBlock">

                <div class="cmn-select-box">
                    <div>Combine Module Number</div>
                    <div>
                        <select id="cmn-dropdown" name="mnId" v-model="cmnId" style="border-radius: 0; font-size: 18px; height: 35px; border: 0; letter-spacing: .8px; border-bottom: 1px solid #8D8D8D; text-transform: uppercase; cursor: pointer; width: 100%; padding: 0 0 8px; transition: all ease .3s;background-color: transparent;margin-top: 10px;">
                            <option :value="cmn" v-for="(cmn, id) in product.combine_module_numbers">{{cmn}}</option>
                        </select>
                    </div>
                </div>


                <div class="ordernowBtn" style="display: flex;align-items: flex-end;">
                    <BuyBtn :product="product" :styles-class="classes" :text="'SEND IT TO ME NOW!'"></BuyBtn>
                </div>

    </div>
</template>

<script>
    import {bus} from '../../bus'
    export default {
        props: ['product'],
        data() {
        },
        created() {
        },
        watch: {
        },
        methods: {
        }
    }
</script>